// rankimgs.js
import rank1 from '../../assets/ranks/private.png'
import rank2 from '../../assets/ranks/privatefirstclass.png'
import rank3 from '../../assets/ranks/specialist.png'
import rank4 from '../../assets/ranks/corporal.png'
import rank5 from '../../assets/ranks/sergeant.png'
import rank6 from '../../assets/ranks/staffsergeant.png'
import rank7 from '../../assets/ranks/sergeantfirstclass.png'
import rank8 from '../../assets/ranks/mastersergeant.png'
import rank9 from '../../assets/ranks/firstsergeant.png'
import rank10 from '../../assets/ranks/sergeantmajor.png'
import rank11 from '../../assets/ranks/commandsergeantmajor.png'
import rank12 from '../../assets/ranks/sergeantmajorofthearmy.png'
import rank13 from '../../assets/ranks/2ndlt.png'
import rank14 from '../../assets/ranks/1stlt.png'
import rank15 from '../../assets/ranks/captain.png'
import rank16 from '../../assets/ranks/major.png'
import rank17 from '../../assets/ranks/lieutenantcol.png'
import rank18 from '../../assets/ranks/colonel.png'
import rank19 from '../../assets/ranks/1general.png'
import rank20 from '../../assets/ranks/2general.png'
import rank21 from '../../assets/ranks/3general.png'
import rank22 from '../../assets/ranks/4general.png'
import rank23 from '../../assets/ranks/5general.png'

let array = [
    rank1,
    rank2,
    rank3,
    rank4,
    rank5,
    rank6,
    rank7,
    rank8,
    rank9,
    rank10,
    rank11,
    rank12,
    rank13,
    rank14,
    rank15,
    rank16,
    rank17,
    rank18,
    rank19,
    rank20,
    rank21,
    rank22,
    rank23
]

export default array